import { SupportEmailRequest } from "src/models/common";
import { endpoints } from "src/utils/api-endpoints";
import axios from 'src/utils/axios';
import { AppResponse } from 'src/models/app-response';


export async function sendSupportEmail(sendingData: SupportEmailRequest): Promise<AppResponse<boolean>> {
  const URL = endpoints.common.sendSupportEmail;
  try {
    const response = await axios.post(URL, sendingData);
    return response.data;
  } catch (error) {
    return {success: false, error};
  }
}

export async function verifyEmail(token: string): Promise<AppResponse<boolean>> {
  const URL = endpoints.common.verifyRegistrationEmail;
  try {
    const response = await axios.post(URL, {token});
    return response.data;
  } catch (error) {
    return {success: false, error};
  }
}
